import { Observable } from 'rxjs';
import { Socket, io } from 'socket.io-client';
import { Model } from '../../model/model';
import { EnvConfig, EnvironnementManager } from '../../model/environnement.manager';

export class SocketIOService {
    private socket: Socket;

    // Connexion du client
    constructor(model: Model) {
        
        let env: EnvConfig = EnvironnementManager.envConfig;
        // console.log(' EnvironnementManager SocketIOService', env)

        let socketServerUrl = env.wsUrl;
        if (socketServerUrl.indexOf("localhost") === -1) {
            socketServerUrl = window.location.origin;
        }
        // console.log('socketServerUrl : ' + socketServerUrl);
        this.socket = io(socketServerUrl, { transports: ["websocket", "polling"], path: "/ws" });
    }

    // Dispatch des messages relatifs aux batchs
    public onAKMMessage = () => {
        return new Observable<any>(observer => {
            this.socket.on('AKM', (data: any) => observer.next(data));
        });
    }

}